import { reactive, readonly } from 'vue'
const state = reactive({ member: null });
export const memberStore = readonly(state);

export async function setMemberStore(member: any) {
    state.member = member;
}
